/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import {createRoot} from 'react-dom/client';
import CustomApp from './CustomApp';
import ErrorBoundary, {safeTr} from './components/ErrorBoundary';
import appConfig from './appConfig';
import '../icons/build/qwc2-icons.css';

// Errors in event handlers and promises do not unmount the application, but would otherwise only show up
// as an anonymous message, so at least make them easy to find
window.addEventListener('unhandledrejection', (ev) => {
    // eslint-disable-next-line no-console
    console.error('[unhandled promise rejection]', ev.reason);
});

// Last resort: all more local error boundaries (plugins, windows, tabs) failed to contain the error
const FatalError = () => (
    <div className="errorboundary-fatal">
        <div>{safeTr("errorboundary.fatal", "Es ist ein unerwarteter Fehler aufgetreten.")}</div>
        <button onClick={() => window.location.reload()} type="button">{safeTr("errorboundary.reload", "Seite neu laden")}</button>
    </div>
);

const root = createRoot(document.getElementById('container'), {
    onUncaughtError: (error, info) => {
        // eslint-disable-next-line no-console
        console.error('[uncaught error]', error, info?.componentStack);
    }
});
root.render(
    <ErrorBoundary fallback={<FatalError />} name="Anwendung">
        <CustomApp appConfig={appConfig}/>
    </ErrorBoundary>
);
